import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const features = [
  {
    icon: FiIcons.FiCpu,
    title: "Scale with 1K+ Apps",
    description: "Connect to everything. From CRMs like Salesforce to productivity tools like Slack, our library covers every major category your team uses daily."
  },
  {
    icon: FiIcons.FiActivity,
    title: "Smarter Compatibility",
    description: "Experience smoother integrations with updated triggers and actions. Nima ensures your data flows exactly where it needs to, without the friction."
  },
  {
    icon: FiIcons.FiFastForward,
    title: "Instant Speed to Value",
    description: "Don't wait weeks for custom builds. Use our ready-to-use connections to launch powerful automations in minutes, not days."
  },
  {
    icon: FiIcons.FiTrendingUp,
    title: "Focus on Real Growth",
    description: "By automating the repetitive, your team is free to focus on attendee experience and strategy. Scale your event, not your workload."
  }
];

const NimaFeatures = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-base font-semibold text-indigo-600 tracking-wide uppercase">The Nima Advantage</h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Powerful Integrations Made Effortless
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">
            Nima removes the technical overhead of event management, allowing you to orchestrate complex workflows through a single, intuitive interface.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="flex gap-6 p-8 bg-white rounded-2xl border border-gray-100 hover:shadow-lg transition-all"
            >
              <div className="flex-shrink-0">
                <div className="p-3 bg-indigo-600 rounded-xl shadow-lg">
                  <SafeIcon icon={feature.icon} className="h-6 w-6 text-white" />
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NimaFeatures;